// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"7a85fcbe","225":"ddd66f8b","498":"e3443fe2","560":"a7a7ecad","703":"88e801a2","787":"cda6f2bd"}[chunkId] + ".chunk.js";
};